import { TEAM_STATUS } from './constants';

export const TEAM_STATUS_DATA = {
  [TEAM_STATUS.STATUS_REQUEST]: {
    id: TEAM_STATUS.STATUS_REQUEST,
    name: 'На рассмотрении',
    attrs: {
      color: 'ui-warning',
      get textColor() {
        return `${this.color}--text text--darken-1`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [TEAM_STATUS.STATUS_ACTIVE]: {
    id: TEAM_STATUS.STATUS_ACTIVE,
    name: 'Заявка принята',
    attrs: {
      color: 'ui-success',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [TEAM_STATUS.STATUS_REJECTED]: {
    id: TEAM_STATUS.STATUS_REJECTED,
    name: 'Заявка отклонена',
    attrs: {
      color: 'ui-error',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [TEAM_STATUS.STATUS_DRAFT]: {
    id: TEAM_STATUS.STATUS_DRAFT,
    name: 'Состав формируется',
    attrs: {
      color: 'ui-neutral',
      get textColor() {
        return `${this.color}--text text--lighten-1`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
};

export default {
  TEAM_STATUS_DATA,
};
